/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { SpacingSize } from './models/spacing-size.interface';

@Component({
  selector: 'tmo-authorable-spacing-size',
  templateUrl: './authorable-spacing-size.component.html',
  styleUrls: ['./authorable-spacing-size.component.scss'],
})
export class SpacingSizeComponent
  extends AuthorableComponent<SpacingSize>
  implements OnInit, OnDestroy
{
  @Input() public css: string;
  /**
   * Whenever this component needs some value to be instantiated on load then
   * values of its properties are initialised in the constructor
   * @returns void
   */
  constructor() {
    super();
  }

  /**
   * Called whenever this component is invoked from parent component
   * @returns void
   */
  public ngOnInit(): void {}

  public setData(data: SpacingSize): void {
    if (this.validate(data)) {
      this.css = data.css;
    }
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data
   */
  public validate(data: SpacingSize): boolean {
    if (!data.css) {
      throw new Error(`Invalid options for SpacingSize ${data}: Required fields [css]`);
    }
    return true;
  }
  /**
   * Destroys all the subscriptions .
   * @returns void
   */
  public ngOnDestroy(): void {}
}
